import { render, staticRenderFns } from "./materialdetail.vue?vue&type=template&id=e7105e3e&"
import script from "./materialdetail.vue?vue&type=script&lang=js&"
export * from "./materialdetail.vue?vue&type=script&lang=js&"
import style0 from "./materialdetail.vue?vue&type=style&index=0&id=e7105e3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports